export const STATE_NAME = 'COMMON';
export const PREFIX = STATE_NAME + '_';

export const CHANGE_LANGUAGE = PREFIX + 'CHANGE_LANGUAGE';
